// Logo Synobatch en composant React — et non en `<img src=...>`.
//
// Vite inline les petits SVG en data-URI ; or un SVG chargé via `<img>` est
// isolé du document : `currentColor` y vaut noir, et le logo devenait illisible
// sur le thème sombre. En JSX, le SVG fait partie du DOM et hérite donc de la
// couleur du texte. L'accent de marque (#D94B43) reste fixe : il contraste sur
// les deux thèmes.
export default function Logo(props) {
  return (
  <svg role="img" aria-label="Synobatch" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 160" >
    <g transform="translate(20, 30)">
      <rect x="2" y="2" width="30" height="30" rx="4" fill="none" stroke="currentColor" strokeWidth="2"></rect>
      <rect x="68" y="68" width="30" height="30" rx="4" fill="none" stroke="currentColor" strokeWidth="2"></rect>
      <path d="M 32 17 H 83 V 60" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.5"></path>
      <path d="M 83 68 L 78 58 L 88 58 Z" fill="currentColor" opacity="0.5"></path>
      <path d="M 68 83 H 17 V 40" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.5"></path>
      <path d="M 17 32 L 12 42 L 22 42 Z" fill="currentColor" opacity="0.5"></path>
      <rect x="40" y="11" width="9" height="12" rx="2" fill="currentColor" opacity="0.35"></rect>
      <rect x="53" y="11" width="9" height="12" rx="2" fill="currentColor" opacity="0.35"></rect>
      <rect x="66" y="11" width="9" height="12" rx="2" fill="#D94B43"></rect>
      <rect x="51" y="77" width="9" height="12" rx="2" fill="#D94B43"></rect>
      <rect x="38" y="77" width="9" height="12" rx="2" fill="currentColor" opacity="0.35"></rect>
    </g>
    <g transform="translate(140, 95)">
      <text fontFamily="Archivo, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif" fontSize="52" fontWeight="500" fill="currentColor">Syno<tspan fill="#D94B43">batch</tspan></text>
      <text y="22" fontFamily="Archivo, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif" fontSize="11" letterSpacing="3" fill="currentColor">COLLECT · SYNC · RUN</text>
    </g>
  </svg>
  );
}
